<template>
  <div class="modal" v-bind:class="{ 'is-active': showmodal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{datamodal.title}}</p>
        <button class="delete" @click="close" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="control has-icons-left">
          <input
            v-model="search"
            autocomplete="off"
            @keydown="keyfunction1($event)"
            id="searchModal"
            class="input is-large"
            type="text"
            placeholder="Buscar"
          />
          <span class="icon is-medium is-left">
            <i class="material-icons">search</i>
          </span>
        </div>
        <table class="table is-bordered is-fullwidth margin-top">
          <tr class="has-background-light">
            <th v-for="title in datamodal.titleTable" :key="title.$index">{{title.name}}</th>
          </tr>
          <tr
            v-for="(data, index) in filteredItems"
            :key="index"
            :id="'m'+index"
            v-bind:class="{ 'is-selected': data.selected }"
            @click="clickData(data,index)"
            class="hand"
          >
            <td v-for="title in datamodal.titleTable" :key="title.$index">{{data[title.cod]}}</td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot">
        <button @click="ok" class="button is-link">{{datamodal.oktext}}</button>
        <button @click="close" class="button">{{datamodal.canceltext}}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      search: "",
      cloneData: [],
      selected: null,
      dataselected: null
    };
  },
  computed: {
    ...mapState(["showmodal", "datamodal"]),
    filteredItems: function() {
      let d = [];
      d = functions.filterItems(
        this.search,
        this.cloneData,
        this.datamodal.titleTable
      );
      return d;
    }
  },
  methods: {
    close() {
      this.search = "";
      this.$store.commit("launchModal");
    },
    keyfunction1(e) {
      if (e.keyCode === 27) {
        // cancelar
        e.preventDefault();
        this.search = "";
        this.$store.commit("launchModal");
      }
      const _this = this;
      let selfilter = null;
      this.filteredItems.forEach(function(k, v) {
        if (k.selected) {
          _this.selected = v;
          selfilter = v;
        }
      });
      let numDatos = this.filteredItems.length;
      if (numDatos === 1) {
        // si solo hay un dato filtrado o
        this.cloneData.forEach(function(k) {
          k.selected = false;
        });
        this.filteredItems[0].selected = true;
        this.selected = 0;
        this.dataselected = this.filteredItems[0];
      }
      if (e.keyCode === 40) {
        e.preventDefault();
        if (numDatos > 1) {
          // si hay mas de un dato
          if (this.selected < numDatos - 1) {
            if (this.dataselected) {
              if (!selfilter) {
                // si dentro de los datos filtrados no hay seleccion
                this.cloneData.forEach(function(k) {
                  k.selected = false;
                });
                this.filteredItems[0].selected = true;
                this.selected = 0;
                this.dataselected = this.filteredItems[0];
              }
              // si ya hay algo seleccionado
              this.filteredItems[this.selected].selected = false;
              this.filteredItems[this.selected + 1].selected = true;
              this.dataselected = this.filteredItems[this.selected + 1];
              this.selected++;
            } else {
              // si todavía no habíab hecho seleccion
              this.filteredItems[0].selected = true;
              this.selected = 0;
              this.dataselected = this.filteredItems[0];
            }
          }
        }
      }
      if (e.keyCode === 38) {
        e.preventDefault();
        if (numDatos > 1) {
          // si hay mas de un dato
          if (this.selected > 0) {
            this.filteredItems[this.selected].selected = false;
            this.filteredItems[this.selected - 1].selected = true;
            this.dataselected = this.filteredItems[this.selected - 1];
            this.selected--;
          }
        }
      }
      if (e.keyCode === 13) {
        // si presiona enter
        e.preventDefault();
        this.ok();
      }
    },
    ok() {
      this.$store.commit("storeDataModal", {
        data: this.dataselected,
        result: this.datamodal.result,
        title: this.datamodal.titleTable
      });
      this.search = "";
      this.$store.commit("launchModal");
    },
    clickData(d, i) {
      this.filteredItems.forEach(function(k, v) {
        if (i === v) {
          k.selected = true;
        } else {
          k.selected = false;
        }
      });
      this.dataselected = d;
      this.selected = i;
      document.getElementById("searchModal").focus();
    }
  },
  watch: {
    showmodal(newv, oldv) {
      if (newv) {
        this.cloneData = [];
        this.cloneData = [...this.datamodal.table];
        this.cloneData.forEach(function(k) {
          k.selected = false;
        });
        this.selected = null;
        this.dataselected = null;
        setTimeout(function() {
          document.getElementById("searchModal").focus();
        }, 100);
      }
    }
  }
};
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/modals/Modal.vue